import { render, staticRenderFns } from "./EditZuschlagsConfiguration.vue?vue&type=template&id=b302fc92"
import script from "./EditZuschlagsConfiguration.vue?vue&type=script&lang=js"
export * from "./EditZuschlagsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports